import { Fragment } from 'react';
import { Col } from 'reactstrap';
import { Searchbar } from './Searchbar';
import { MoonLight } from './MoonLight';
import { Notificationbar } from './Notificationbar';
import { UserHeader } from './UserHeader';

/** CUBA RightHeader — nav-menus composition */
export function RightHeader() {
  return (
    <Fragment>
      <Col xxl="7" xl="6" md="7" className="nav-right pull-right right-header col-8 p-0 ms-auto">
        <ul className="simple-list nav-menus flex-row">
          <Searchbar />
          <MoonLight />
          <Notificationbar />
          <UserHeader />
        </ul>
      </Col>
    </Fragment>
  );
}
